import { isDev } from './isDev';

export function getSettingFromAppRoot(window: Window): {
  serverUri: string;
  imagesProxyUri: string;
  apiUri: string;
  sentryHost: string;
} {
  const fallback = isDev() ? {
    serverUri: `://${window.location.hostname}`,
    apiUri: 'http://localhost:3232/server/',
    imagesProxyUri: 'https://stage.k8s-belimo.xiag.ch',
    sentryHost: 'stage.k8s-belimo.xiag.ch',
  } : {
    serverUri: `https://${window.location.hostname}/`,
    apiUri: `https://${window.location.hostname}/server/`,
    imagesProxyUri: `https://${window.location.hostname}`,
    sentryHost: `${window.location.hostname}`,
  };
  const appRoot = window.document.querySelector<HTMLElement>('app-root');
  if (appRoot === null) {
    return fallback;
  }
  const serverUri = appRoot.getAttribute('server-uri')
  const apiUri = appRoot.getAttribute('api-uri');
  const imagesProxyUri = appRoot.getAttribute('images-proxy-uri');
  const sentryHost = appRoot.getAttribute('sentry-host');
  return {
    ...fallback,
    ...(serverUri ? { serverUri }: {}),
    ...(apiUri ? { apiUri }: {}),
    ...(imagesProxyUri ? { imagesProxyUri }: {}),
    ...(sentryHost ? { sentryHost }: {}),
  }
}
